import { render, staticRenderFns } from "./ItemWireGuardConfig.vue?vue&type=template&id=b29db680&scoped=true"
import script from "./ItemWireGuardConfig.vue?vue&type=script&lang=js"
export * from "./ItemWireGuardConfig.vue?vue&type=script&lang=js"
import style0 from "./ItemWireGuardConfig.vue?vue&type=style&index=0&id=b29db680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29db680",
  null
  
)

export default component.exports